import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAnnotationLines20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconAnnotationLines20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15 8a3 3 0 1 0-2.595-1.494L6.6 12.463a3 3 0 1 0 1.029 1.093l5.828-5.982c.45.27.978.426 1.542.426M5 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAnnotationLines20);
